import gql from "graphql-tag"

export default gql`
  query allTags($user: String!, $tagName: String!) {
    allSlideTags: slideTags(
      filter: {
        name: { equalTo: "album-cover" }
        user: { username: { equalTo: $user } }
      }
    ) {
      id
      slides {
        id
        file: image {
          id
          secret
        }
        videoUrl
        width
        height
        title
        description
        album {
          id
          slug
        }
      }
    }
    allTags: albumTags(
      filter: {
        user: { username: { equalTo: $user } }
        name: { equalTo: $tagName }
      }
    ) {
      id
      albums(filter: { hidden: { equalTo: false } }, orderBy: TITLE_ASC) {
        id
        slug
        order: pos
        title
        description
        tags {
          id
          name
        }
        keyValues {
          id
          key {
            id
            name
          }
          value
        }
        slides(orderBy: POS_ASC, first: 1) {
          id
          file: image {
            id
            secret
          }
          videoUrl
          width
          height
          title
          description
        }
      }
    }
  }
`
